import { Injectable } from '@angular/core';
import * as citiesActions from '../../core/cities/store/actions/cities.action';
import { Store, select } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {
  constructor(private store: Store) { }
  userInfo: any;

  setUserInfo(user) {
    if (!user.default_city) {
      console.error('default_city is not defined in the provided user object');
      return;
    }
    this.userInfo = user;
    localStorage.setItem('user', JSON.stringify(user)); 
  }

  getUserInfo(): any {
    const user = localStorage.getItem('user');
    if (user) {
      this.userInfo = JSON.parse(user);
      return this.userInfo;
    }
    return null;
  }

  setAuthToken(authToken) {
    localStorage.setItem('authToken', authToken);
  }

  getAuthToken() {
    return localStorage.getItem('authToken');
  }

  removeUserInfo() {
    localStorage.removeItem('user');
  }

  removeAuthToken() {
    localStorage.removeItem('authToken');
  }

  getRoleId(): number | null {
    const userInfo = this.getUserInfo();
    if (userInfo && userInfo.role && userInfo.role.id) {
      return userInfo.role.id;
    }
    return null;
  }

}

